import { Button } from '@chakra-ui/react';
import { Form, useFormikContext } from 'formik';
import React from 'react';
import { getFormErrors } from '../../../services/form/getFormErrors';
import { localise } from '../../../services/lang/lang';
import { FormContainer } from '../Form/FormContainer';
import { useTrackUnsavedChanges } from '../UnsavedChanges/useTrackUnsavedChanges';
import TagSelect from '../../pages/RemoteSubmission/TagSelect';
import StandardFormSelect from '../Form/StandardFormSelect';
import ModalButtonContainer from '../Modal/ModalButtonContainer';
const OfficerAssessmentDetailsForm = ({ hazards, actionTypes, canEdit, }) => {
    const { handleSubmit, values, errors, dirty, isSubmitting, setFieldValue } = useFormikContext();
    useTrackUnsavedChanges(dirty);
    return (React.createElement(Form, { "data-testid": "officer_assessment_form" },
        React.createElement(FormContainer, null,
            React.createElement(StandardFormSelect, { onChange: (id) => {
                    setFieldValue('action_type_id', id);
                }, groups: [
                    {
                        options: actionTypes,
                    },
                ], nameField: "name", label: localise('ACTION'), isDisabled: !canEdit, useRow: true, "data-testid": "officer_assessment_form__action_type", error: getFormErrors(errors, 'action_type_id'), value: values.action_type_id }),
            React.createElement(TagSelect, { isDisabled: !canEdit, models: hazards, useRow: true, nameField: "name", label: "Hazards", "data-testid": "officer_assessment_form__hazards", value: undefined, selectIds: values.hazards ?? [], onChange: (selected) => setFieldValue('hazards', selected), error: getFormErrors(errors, 'hazards') }),
            React.createElement(ModalButtonContainer, null,
                React.createElement(Button, { isDisabled: !dirty || isSubmitting || !canEdit, isLoading: isSubmitting, onClick: () => handleSubmit(), variant: "primary" }, localise('SAVE'))))));
};
export default OfficerAssessmentDetailsForm;
